<template>
  <div class="wrapper container">
    <div class="content">
      <h2>TGO 鲲鹏会学员培训师章程</h2>
      <div class="new-member">
        <h4>培训师概述</h4>
        <p>TGO 鲲鹏会是一个学员共建的组织，本章程设立的目的，是为了通过共建的方式吸纳更多学员参与到 TGO 鲲鹏会学员服务体系中，传递 TGO 鲲鹏会的先进理念和学员的优秀经验，帮助学员个人更好地学习和成长，帮助学员企业之间更好地合作和交流，进而促进创新技术和商业更好地融合，推动社会的进步。</p>
        <p>TGO 鲲鹏会学员培训师（以下简称学员培训师）指的是，在册的 TGO 鲲鹏会学员，主动申请或由 TGO 鲲鹏会总部邀请，经过 TGO 鲲鹏会总部培训并通过 TGO 鲲鹏会总部考核和认证，具备培训 TGO 鲲鹏会学员资质的人选。</p>
        <p class="link">更多内容详见<a href="https://tower.im/teams/612908/todos/5238/">《TGO 鲲鹏会学员培训师章程-TGO 鲲鹏会总部-2019年9月》</a></p>
        <!-- <h4>现有培训师队伍</h4> -->
        <img v-if="!isMobile" src="https://static001.geekbang.org/resource/image/04/e6/0411433b795cb5e2ff5db0780f01c3e6.png" class="img" alt="">
        <img class="image-m" v-else src="@/assets/img/image.png" alt="">
        <h4>申请加入</h4>
        <p>欲申请 TGO 鲲鹏会学员培训师，可以直接联系 TGO 鲲鹏会客服 E 小欧（手机/微信：18518983363）</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      isMobile: 'isMobile'
    })
  },
  created () {
  },
  mounted () {
  }
}
</script>
<style scoped lang='scss'>
  @import "../../style/bulma/app.sass";

  .wrapper {
    width: 775px;
    @include mobile {
      width: 92vw;
    }
  }
  .content {
    margin: 0 auto;
    margin-bottom: 40px;
    h2 {
      margin-top: 64px;
      font-weight: bold;
    }
    h6 {
      font-weight: bold;
      margin-top: 30px;
    }
    .new-member,.group-leader {
      padding-top: 50px;
      h4 {
        font-weight: bold;
        border-left: 3px solid $primary3;
        padding-left: 10px;
        margin-bottom: 18px;
      }
      p {
        line-height: 2;
      }
      .image-m {
        width: 92vw;
        height: auto;
      }
    }
    .group-leader {
      padding-top: 40px;
    }
    img {
      margin-bottom: 20px;
    }
  }
  .pingfang-family {
    font-family: PingFang SC;
  }
</style>
